<script>
  import { onMount } from "svelte"
  import { user } from "../../stores/User"
  import { BASE_URL } from "../../stores/BASE_URL"
  import SinInformacion from "../../components/Sin_informacion.svelte"
  import Spinner from "../../components/Spinner.svelte"
  import { navigate } from "svelte-routing"

  export let documento

  let data = {
    persona: null,
    loading: true,
  }

  let error = ""
  let controller

  const consultar = async (ops, signal, adicionales = {}) => {
    const query = new URLSearchParams({ documento, session_key: $user.session_key, ops, ...adicionales })
    const response = await fetch(`${BASE_URL}persona.php?${query}`, { signal })
    if (!response.ok) throw new Error("No se pudo consultar la empresa laboral.")
    const resp = await response.json()
    if (resp.status === "error") {
      if (String(resp.data?.error_id) === "405") navigate("/", { replace: true })
      throw new Error(resp.data?.message || "No se pudo consultar la empresa laboral.")
    }
    return resp.data
  }

  const obtenerEmpresa = (respuesta) => {
    const empresa = Array.isArray(respuesta) ? respuesta[0] : respuesta
    return empresa && typeof empresa === "object" && (empresa.ruc || empresa.razonsocial) ? empresa : null
  }

  const cargarDatos = async () => {
    controller?.abort()
    const actual = new AbortController()
    controller = actual
    data = { persona: null, loading: true }
    error = ""

    try {
      let empresa = obtenerEmpresa(await consultar("laboral_empresa", actual.signal))
      if (!empresa) {
        // La lista laboral puede incluir periodos que laboral_empresa no consulta.
        const registros = await consultar("laboral_datos", actual.signal)
        const ultimo = Array.isArray(registros)
          ? registros.find((registro) => /^\d{11}$/.test(String(registro?.ruc ?? "").trim()))
          : null
        if (ultimo) {
          empresa = obtenerEmpresa(await consultar("adicional_empresa_general_datos", actual.signal, { ruc: ultimo.ruc }))
            || { ruc: ultimo.ruc, razonsocial: ultimo.razonsocial }
        }
      }
      if (!actual.signal.aborted) data.persona = empresa
    } catch (err) {
      if (!actual.signal.aborted) error = err.message || "No se pudo cargar la empresa laboral."
    } finally {
      if (!actual.signal.aborted) data.loading = false
    }
  }

  onMount(() => {
    cargarDatos()
    return () => controller?.abort()
  })
</script>

{#if data.loading === true}
  <Spinner />
{:else if error}
  <div class="alert theme-danger" role="alert">
    {error}
    <button type="button" class="btn btn-sm btn-outline theme-danger ms-3" on:click={cargarDatos}>Reintentar</button>
  </div>
{:else if !data.persona}
  <SinInformacion />
{:else}
  <div class="table-responsive">
    <table class="table table-striped table-sm">
      <tbody>
        <tr>
          <th class="fg-secondary fw-normal">RUC</th>
          <td>{data.persona.ruc}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Razón social</th>
          <td>{data.persona.razonsocial}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Comercial</th>
          <td>{data.persona.nombrecomercial || "Sin registrar"}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Tipo</th>
          <td>{data.persona.tipo || "Sin registrar"}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Giro</th>
          <td>{data.persona.giro || "Sin registrar"}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Estado</th>
          <td>{data.persona.estado || "Sin registrar"}</td>
        </tr>
        <tr>
          <th class="fg-secondary fw-normal">Condición</th>
          <td>{data.persona.condicion || "Sin registrar"}</td>
        </tr>
      </tbody>
    </table>
  </div>
{/if}
